import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FeatureInfoType } from 'angular-components/feature-info/feature-info-type';

@Component({
  selector: 'eurogard-feature-text-text',
  template: `
    @switch (featureInfoType) {
      @case ('beta') {
        <span class="bg-[#7c3aed] text-white font-black px-[2px] py-[1px] rounded-sm">BETA</span>
      }
      @case ('deprecated') {
        <span class="bg-[#ffa500] text-white font-black px-[2px] py-[1px] rounded-sm">DEPR</span>
      }
      @case ('new') {
        <span class="bg-[#1e88e5] text-white font-black px-[2px] py-[1px] rounded-sm">NEW</span>
      }
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureInfoTextComponent {
  @Input() featureInfoType?: FeatureInfoType;
}
